import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const CrmHomePage = lazy(() => import('./crm-home-page').then((m) => ({ default: m.CrmHomePage })));

export const crmHomeRoute: RouteObject = { index: true, element: <CrmHomePage /> };
